<!--child-->
<ng-container *ngIf="data$ | async as data">
  <ul class="col" *ngFor="let child of data.navigationNode.children">
    <ng-container *ngFor="let child2 of child.children">
      <li class="row" *ngFor="let entry of child2.entries; trackBy: trackByMethod">
        <button
          class="accordion-toggle"
          (click)="accordionToggleClick($event)"
          [id]="'toggle-' + entry?.itemId"
          [attr.aria-expanded]="false"
          [attr.aria-controls]="'accordion-' + entry?.itemId"
          aria-label="Toggle navigation section"
        ></button>
        <dl
          class="accordion"
          [attr.id]="'accordion-' + entry?.itemId"
          [attr.aria-labelledby]="'toggle-' + entry?.itemId"
          role="region"
        >
          <h4>
            <ng-template
              [cxComponentWrapper]="{
                flexType: entry.itemType,
                typeCode: entry.itemType,
                uid: entry?.itemId,
              }"
            >
            </ng-template>
          </h4>
          <dd *ngFor="let child3 of child2.children">
            <ng-container *ngFor="let entry of child3.entries">
              <ng-template
                [cxComponentWrapper]="{
                  flexType: entry.itemType,
                  typeCode: entry.itemType,
                  uid: entry?.itemId,
                }"
              >
              </ng-template>
            </ng-container>
          </dd>
        </dl>
      </li>
    </ng-container>
  </ul>
</ng-container>
